/**
 * Trigger a file download without opening a new browser tab.
 * Uses a hidden iframe so cross-origin S3 URLs do not navigate the SPA
 * (which would fire beforeunload and clear session localStorage).
 *
 * @param {string} url
 */
export function downloadFromUrl(url) {
  if (!url) return;

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
  window.setTimeout(() => {
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  }, 60000);
}
